<template>
	<div class="authentication">
		<div class="title">
			<div  :class="tab==1 ?'tabcolor':'' ">认证中心</div>
			<div  :class="tab==2 ?'tabcolor':'' ">审核成功</div>
			<!-- <div  :class="tab==2 ?'tabcolor':'' ">正在审核</div> -->
			<div  :class="tab==3 ?'tabcolor':'' ">审核失败</div>
		</div>
		<div class="conent">
			
			<div class="form">
				<div class="conent-title">学校认证</div>
				<div class="conent-conent">
					<div class="left">
						<input class="input" type="text"  v-model="school_name" placeholder="请输入学校名称" />
						    <el-date-picker
						      v-model="school_date"
						      type="date"
						      placeholder="人学时间">
						    </el-date-picker>
						
					</div>
					
					<el-upload
					  class="avatar-uploader3 right"
					  action="http://2.silubei.com/api/v1/upload"
					  :show-file-list="false"
					  :on-success="handleAvatarSuccess"
					  :before-upload="beforeAvatarUpload">
					  <img v-if="school_img && school_img!='http://cccss.oss-cn-beijing.aliyuncs.com'" :src="school_img" class="avatar" style="width: 9rem;">
					  <img v-if="!school_img || school_img=='http://cccss.oss-cn-beijing.aliyuncs.com'"  src="../../assets/shudo/images/u736.svg" />
					  
					  <div v-if="!school_img">请上传学生证照片</div>
					</el-upload>
				</div>
			</div>
			<div class="form">
				<div class="conent-title">身份证认证</div>
				<div class="conent-conent">
					<div class="left">
						<input class="input" type="text" v-model="identity_name"  placeholder="请输入身份证姓名" />
						<input class="input" type="text" v-model="identity_number"  placeholder="请输入身份证号码" />
					</div>
					<el-upload
					  class="avatar-uploader2 right"
					  action="http://2.silubei.com/api/v1/upload"
					  :show-file-list="false"
					  :on-success="handleAvatarSuccess1"
					  :before-upload="beforeAvatarUpload"
					  >
					  <img v-if="identity_img && identity_img!='http://cccss.oss-cn-beijing.aliyuncs.com'" :src="identity_img" class="avatar" style="width: 9rem;">
					  <img v-if="!identity_img || identity_img=='http://cccss.oss-cn-beijing.aliyuncs.com'"  src="../../assets/shudo/images/u736.svg" />
					  
					  <div v-if="!identity_img">请上传证明资料</div>
					</el-upload>
					
				</div>
			</div>
			
			
			
			<div class="form">
				<div class="conent-title">其他认证</div>
				<div class="conent-conent">
					<div class="left">
						<el-select style="margin-left: 9px;width: 238px;border: 1px solid #0000004a;border-radius:0.3125rem" v-model="qi_type" placeholder="请选择活动区域">
							<el-option v-for="(item,index) in attestation" :key="index"  :label="item.name" :value="item.name"></el-option>
							<!-- <el-option label="区域二" value="beijing"></el-option> -->
						</el-select>
						<!-- <input class="input" type="text" v-model="qi_type"  placeholder="选择认证方式（下拉选择）" /> -->
						<input class="input" type="text" v-model="qi_name"  placeholder="请输入需要认证的名称" />
						
					</div>
					<el-upload
					  class="avatar-uploader1 right"
					  action="http://2.silubei.com/api/v1/upload"
					  :show-file-list="false"
					  :on-success="handleAvatarSuccess2"
					  :before-upload="beforeAvatarUpload"
					  >
					  <img v-if="qi_img && qi_img!='http://cccss.oss-cn-beijing.aliyuncs.com'" :src="qi_img" class="avatar" style="width: 9rem;">
					  <img v-if="!qi_img || qi_img=='http://cccss.oss-cn-beijing.aliyuncs.com'"  src="../../assets/shudo/images/u736.svg" />
					  
					  <div v-if="!qi_img">请上传证明资料</div>
					</el-upload>
					
				</div>
			</div>
			
			<el-button type="danger" @click="buttonClick()" round>提交</el-button>
			
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				tab: 0,
				school_img   : '',
				school_name  : '',
				school_date  : '2021-3-30',
				identity_img : '',
				identity_name: '',
				identity_number : '',
				qi_img       : '',
				qi_name      : '',
				qi_type      : '',
				attestation  : []
			}
		},
		created() {
			let that = this;
			that.$http('get','/api/v1/user/attestationinfo',{}) .then(function (res) {  //推荐用户
				if(res.data.info){
					that.school_img    = res.data.info.school_img;
					that.identity_img  = res.data.info.identity_img;
					that.school_name  = res.data.info.school_name;
					that.identity_name  = res.data.info.identity_name;
					that.identity_number  = res.data.info.identity_number;
					that.qi_img  = res.data.info.qi_img;
					that.qi_name  = res.data.info.qi_name;
					that.qi_type  = res.data.info.qi_type;
					that.tab      = res.data.info.status; 
					that.school_date  = res.data.info.school_date;
					console.log(that.school_date);
				}
				
			});
			that.$http('get','/api/v1/attestations/list',{}) .then(function (res) {  
				that.attestation  = res.data.list;
				console.log(res);
			});
			
			
		},
		methods:{
			tabClick(e){
				this.tab = e;
			},
			handleAvatarSuccess(res, file) {
				
				this.school_img = res.data;
			},
			handleAvatarSuccess1(res,file){
				this.identity_img= res.data;
			},
			handleAvatarSuccess2(res,file){
				this.qi_img = res.data;
			},
			beforeAvatarUpload(file) {
				const isJPG = file.type === 'image/jpeg';
				const isLt2M = file.size / 1024 / 1024 < 2;
				if (!isJPG) {
				  this.$message.error('上传图片只能是 JPG 格式!');
				}
				if (!isLt2M) {
				  this.$message.error('上传图片大小不能超过 2MB!');
				}
				return isJPG && isLt2M;
			},
			
			buttonClick(){
				let that   = this;
				var parme  = {
					school_img:that.school_img,
					school_name:that.school_name,
					school_date:that.school_date,
					identity_img:that.identity_img,
					identity_name:that.identity_name,
					identity_number:that.identity_number,
					qi_img         : that.qi_img,
					qi_name        : that.qi_name,
					qi_type        : that.qi_type
				};
				that.$http('post','/api/v1/user/attestationupd',{school_img:that.school_img,
					school_name:that.school_name,
					school_date:that.school_date,
					identity_img:that.identity_img,
					identity_name:that.identity_name,
					identity_number:that.identity_number,
					qi_img         : that.qi_img,
					qi_name        : that.qi_name,
					qi_type        : that.qi_type}) .then(function (res) {  //推荐用户
					that.$message({
					    message: res.msg,
						showClose: true,
					    type: 'success'
					});
					console.log(res);
				});
				
				
			}
		},
	}
	
</script>

<style lang="less">
	.authentication {
		width: 100%;
		min-height: 25rem;
		color: #7F7F7F;
		.title {
			width: 92%;
			margin: auto;
			border-bottom:1px solid #a29e9eb5;
			line-height: 2rem;
			height: 2rem;
			display: flex;
			div {
				padding-left: 0.2rem;
				width:5.6rem;
				text-align: center;
				height: 2rem;
			}
			.tabcolor {
				border-bottom:2px solid #d63030;
			}
		}
		.conent {
			width: 100%;
			// margin-top: 2rem;
			.form {
				width: 60%;
				margin: auto;
				margin-top: 2rem;
				.conent-title {
					padding-left: 0.4rem;
					border-left: 0.4rem solid #d63030 ;
				}
				.conent-conent {
					margin-left: 0.6rem;
					margin-top: 1rem;
					display: flex;
					.left {
						flex: 2;
						.el-date-editor {
							margin-left: 0.5rem;
							width: 15rem;
							border: 1px solid #0000004a;
							border-radius: 0.3rem;
						}
						.input {
							width: 14.4rem;
							border: 1px solid #0000004a;
							height: 2.2rem;
							display: block;
							margin: 0.6rem;
							border-radius: 0.3rem;
							padding-left: 0.3rem;
						}
						.input::-webkit-input-placeholder{
						    color: #0000004a;
						}
					}
					.right {
						flex: 1;
						img {
							display: block;
							margin: auto;
							padding-top: 1rem;
						}
						div {
							text-align: center;
							line-height: 2.3rem;
						}
					}
				}
			}
		}
		.is-round {
			margin-top: 2rem;
			margin-left: 16rem;
			line-height: 0.6rem;
			width: 6rem;
			height: 2rem;
			background-color: #d63030;
		}
	}
</style>
